import styled from "@emotion/styled"
import { leadingNormal } from "@porsche-design-system/components-react/emotion"
import { SkeletonComponent } from "./SkeletonComponent"

export const SkeletonSwitch = styled(SkeletonComponent)`
	border-radius: calc(calc(${leadingNormal} + 2px * 2) / 2);
	height: calc(${leadingNormal} + 2px * 2);
	width: calc(${leadingNormal} * 2);
`
